import React from "react";
import './DoubleArrowIcon.css'

function DoubleArrowIcon() {
    return (
        <svg width="12" height="14" xmlns="http://www.w3.org/2000/svg">
            <path d="m6.00712,0.07678l-0.57984,0.52341l-5.4495,4.98491l1.15747,1.36631l4.86967,-4.45468l4.87192,4.45468l1.15746,-1.36631l-5.44954,-4.98491l-0.57984,-0.52341l0.00219,0l0.00001,0z"/>
            <path d="m5.93831,13.94936l0.56867,-0.5185l5.34462,-4.93812l-1.13528,-1.3535l-4.77587,4.41289l-4.77805,-4.41289l-1.13519,1.35349l5.34458,4.93814l0.56866,0.5185l-0.00214,0z" />
        </svg>
    );
}

export default DoubleArrowIcon;